import React, { useEffect, useState } from 'react';

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalProducts: 0,
    totalOrders: 0,
    totalUsers: 0,
    totalSales: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchStats = async () => {
      const token = localStorage.getItem('adminToken');

      if (!token) {
        setError('Unauthorized: Admin token missing');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError('');

        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/dashboard-stats`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) throw new Error('Failed to fetch dashboard stats');
        const data = await res.json();
        setStats(data);
      } catch (err) {
        setError(err.message || 'Error fetching dashboard data');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center text-success fw-bold">Admin Dashboard</h2>

      {loading && <div className="text-center text-muted">Loading stats...</div>}
      {error && <div className="alert alert-danger text-center">{error}</div>}

      {!loading && !error && (
        <div className="row g-4">
          <StatCard title="Total Products" value={stats.totalProducts} icon="bi-box-seam" bg="success-subtle" />
          <StatCard title="Total Orders" value={stats.totalOrders} icon="bi-cart-check" bg="success-subtle" />
          <StatCard title="Total Users" value={stats.totalUsers} icon="bi-people" bg="success-subtle" />
          <StatCard
            title="Total Sales"
            value={`₹${(stats.totalSales || 0).toLocaleString()}`}
            icon="bi-currency-rupee"
            bg="success-subtle"
          />
        </div>
      )}
    </div>
  );
};

const StatCard = ({ title, value, icon, bg }) => {
  return (
    <div className="col-12 col-sm-6 col-lg-3">
      <div className={`card border-0 shadow-sm h-100 bg-${bg} text-dark rounded`}>
        <div className="card-body d-flex flex-column align-items-center justify-content-center text-center">
          <i className={`bi ${icon} fs-1 text-success mb-2`} title={title}></i>
          <h6 className="card-title">{title}</h6>
          <p className="display-6 fw-bold">{value}</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
